import React from 'react';
import { useLocation } from 'react-router-dom';

import { PartList } from './PartList';

/** Route component for `/parts/search`. Remounts PartList whenever the path
 *  changes so deep-linked saved-report URLs reset state on navigation. */
export const Parts: React.FC = () => {
  const location = useLocation();
  return <PartList key={location.pathname} />;
};
